import { createContext } from 'react';

import { CacheContextInterface, DefaultInterface } from '../../models/services/cache-context-interface';

const CacheContext = createContext<CacheContextInterface>(DefaultInterface);

export { CacheContext };